import { useEffect, useRef } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { getLocale, isLocale } from '@/i18n'
import { useLocale } from '@/i18n/LocaleProvider'
import { patchMeLocale } from '@/lib/api'
import { useAuth } from '@/lib/auth'

/** Після логіну мова з акаунта; перемикач пише users.locale. */
export function LocaleSync() {
  const { me } = useAuth()
  const { locale, setLocale } = useLocale()
  const queryClient = useQueryClient()
  const skipPersist = useRef(true)

  useEffect(() => {
    if (!me) {
      skipPersist.current = true
      return
    }
    const fromUser = isLocale(me.user.locale) ? me.user.locale : null
    if (fromUser) {
      if (fromUser !== getLocale()) {
        skipPersist.current = true
        setLocale(fromUser)
      } else {
        skipPersist.current = false
      }
      return
    }
    skipPersist.current = false
    void patchMeLocale(getLocale())
      .then((data) => {
        queryClient.setQueryData(['me'], data)
      })
      .catch(() => {
        /* локаль лишається на пристрої */
      })
    // Лише при зміні акаунта: інакше відповідь PATCH відкотить перемикач.
  }, [me?.user.id, queryClient, setLocale])

  useEffect(() => {
    void queryClient.invalidateQueries({ queryKey: ['alerts'] })
    void queryClient.invalidateQueries({ queryKey: ['risk'] })
    void queryClient.invalidateQueries({ queryKey: ['reconciliation'] })
    void queryClient.invalidateQueries({ queryKey: ['counterparties'] })
  }, [locale, queryClient])

  useEffect(() => {
    if (!me) return
    if (me.user.locale === locale) {
      skipPersist.current = false
      return
    }
    if (skipPersist.current) return
    void patchMeLocale(locale)
      .then((data) => {
        queryClient.setQueryData(['me'], data)
      })
      .catch(() => {
        /* наступний логін підхопить з акаунта лише після успішного PATCH */
      })
  }, [locale, me, queryClient])

  return null
}
